'use client';
import * as DS from '@aurorasolar/ds';
import { IGridItemSize } from '@aurorasolar/ds';
import { useCallback, useEffect, useState } from 'react';

import { PostSummary } from '@/app/home-solar/blog/actions';
import { PostPreview } from '@/app/home-solar/blog/BlogOverview/PostPreview';

const MOBILE_VISIBLE_COUNT = 1;

type Props = {
  onNavigate: (slug: string) => void;
  pageSize: number;
  posts: PostSummary[];
  size?: DS.IResponsiveProperty<IGridItemSize>;
};

const defaultSize = { _: 'full', md: 'third' } as DS.IResponsiveProperty<IGridItemSize>;

export const SlideshowPostList = ({ onNavigate, pageSize: pageSizeLg, posts = [], size = defaultSize }: Props) => {
  const [page, setPage] = useState(1);

  const breakpoint = DS.useBreakpoint();
  const pageSize = breakpoint === 'sm' ? MOBILE_VISIBLE_COUNT : pageSizeLg;

  const totalPages = Math.ceil(posts.length / pageSize);
  const startIndex = (page - 1) * pageSize;

  const paginatedPosts = posts.slice(startIndex, startIndex + pageSize);
  const showPagination = !((breakpoint === 'lg' || breakpoint === 'xl') && totalPages <= 3);

  useEffect(() => {
    if (page > totalPages && totalPages > 0) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage + 1);
  }, []);

  if (!paginatedPosts.length) {
    return (
      <DS.Flex alignItems="center" justifyContent="center">
        No posts found
      </DS.Flex>
    );
  }

  return (
    <>
      <DS.Grid columnGap={{ _: 0, md: 8 }} rowGap={8}>
        {paginatedPosts.map((post) => (
          <DS.GridItem alignItems="stretch" display="flex" key={post.slug} size={size}>
            <PostPreview onNavigate={onNavigate} post={post} />
          </DS.GridItem>
        ))}
      </DS.Grid>

      {showPagination ? (
        <>
          <DS.Divider my={6} />

          <DS.Flex alignItems="center">
            <DS.Pagination
              currentPage={page - 1}
              handlePageChange={handlePageChange}
              key={String(breakpoint)}
              numberOfPages={totalPages}
              numberOfResults={paginatedPosts.length}
              numberOfResultsPerPage={pageSize}
              renderResultHintText={() => ''}
            />
          </DS.Flex>
        </>
      ) : null}
    </>
  );
};
